import { useQuery } from 'react-query'

import { getSpecialties } from '../../apis/public.api'

export interface ISpecialty {
  id: string;
  createdAt: Date;
  name: string;
  status: string;
}

function useSpecialtyList() {
  return useQuery(['specialty-list'], async () => {
    const data: ISpecialty[] = await getSpecialties();

    const specialtyData = {
      speacialtyList: data,
      total: data.length,
    }

    return specialtyData;
  },
  )
}

export { useSpecialtyList }
